import InputField, { InputTitle } from "@Molecule/InputField";
import Styles from "./sytyles.module.scss";

import Icon from "@Atom/Icon";
import ToggleButtonPIC from "@Atom/ToggleButtonPIC";
import Dropdown from "@Atom/DropDown";
import InputDateField from "@Molecule/InputDateField";
import Radio from "@Atom/Radio";
import { useState } from "react";
import NewAutoComplete from "@Atom/NewAutoComplete";
import { ListSkillsJobSeekers } from "@Helpers/listSkillsJobSeeker";

export default function ThirdStep({
  thirdStep,
  setThirdStep,
  validate = false,
}) {
  const [value, setValue] = useState("");
  const optionsExperiences = [
    {
      name: "Fresh Graduate",
      code: "Fresh Graduate",
    },
    {
      name: "1-3 tahun pengalaman",
      code: "1-3 tahun",
    },
    {
      name: "4-5 tahun pengalaman",
      code: "4-5 tahun",
    },
    {
      name: "5+ tahun pengalaman",
      code: "> 5 tahun",
    },
  ];

  const optionsEducations = [
    {
      name: "SMP Sederajat",
    },
    {
      name: "SMA Sederajat",
    },
    {
      name: "Diploma (D3 & D4)",
    },
    {
      name: "S1",
    },
    {
      name: "S2",
    },
    {
      name: "S3",
    },
  ];

  return (
    <div className={Styles.container}>
      <div className={Styles.block}>
        <InputTitle title={"Pengalaman Minimum Kandidat"} required />
        <div className={Styles.listBox}>
          {optionsExperiences?.map((el, idx) => {
            return (
              <div key={idx}>
                <Radio
                  isError={validate && !thirdStep?.experiences}
                  isChecked={thirdStep?.experiences === el?.code}
                  setIsChecked={() => {
                    setThirdStep((prev) => ({
                      ...prev,
                      experiences: el?.code,
                    }));
                  }}
                />
                <span>{el?.name || "-"}</span>
              </div>
            );
          })}
        </div>
      </div>

      <div className={Styles.block}>
        <InputTitle
          title={"Pendidikan minimum kandidat yang Anda cari"}
          required
        />
        <div className={Styles.listBox}>
          {optionsEducations?.map((el, idx) => {
            return (
              <div key={idx}>
                <Radio
                  isError={validate && !thirdStep?.educations}
                  isChecked={thirdStep?.educations === el?.name}
                  setIsChecked={() => {
                    setThirdStep((prev) => ({
                      ...prev,
                      educations: el?.name,
                    }));
                  }}
                />
                <span>{el?.name || "-"}</span>
              </div>
            );
          })}
        </div>
      </div>

      <div className={Styles.block}>
        <InputTitle title={"Keterampilan yang dibutuhkan"} required />
        <NewAutoComplete
          isErrorText={
            validate &&
            thirdStep?.skills?.filter((el) => el?.action !== "DELETE")
              ?.length === 0 &&
            "Keterampilan belum diisi"
          }
          isError={
            validate &&
            thirdStep?.skills?.filter((el) => el?.action !== "DELETE")
              ?.length === 0
          }
          onReset={(e) => {
            const updated = thirdStep?.skills?.map((el) => {
              if (el?.name === e?.name) {
                return {
                  ...el,
                  action: "DELETE",
                };
              } else {
                return el;
              }
            });

            setThirdStep((prev) => ({
              ...prev,
              skills: updated,
            }));
          }}
          options={ListSkillsJobSeekers() || []}
          value={value}
          setValue={setValue}
          placeholder={"Tuliskan keterampilan kandidat yang kamu butuhkan"}
          selectedItem={
            thirdStep?.skills?.filter((el) => el?.action !== "DELETE") || []
          }
          onClickOption={(e) => {
            if (thirdStep?.skills?.find((el) => el?.name === e?.name)) {
              const updated = thirdStep?.skills?.map((el) => {
                if (el?.name === e?.name) {
                  return {
                    ...el,
                    action: "CREATE",
                  };
                } else {
                  return el;
                }
              });

              setThirdStep((prev) => ({
                ...prev,
                skills: updated,
              }));
            } else {
              setThirdStep((prev) => ({
                ...prev,
                skills: [
                  ...prev?.skills,
                  {
                    ...e,
                    action: "CREATE",
                  },
                ],
              }));
            }
          }}
        />
      </div>

      <div className={Styles.block}>
        <InputTitle title={"Pertanyaan tambahan"} />
        {thirdStep?.questions?.filter((el) => el?.action !== "DELETE")?.length >
          0 && (
          <div className={Styles.questionBox}>
            {thirdStep?.questions
              ?.filter((el) => el?.action !== "DELETE")
              ?.map((el, idx) => {
                return (
                  <div className={Styles.question} key={idx}>
                    <div className={Styles.headerQuestion}>
                      <span>Pertanyaan {idx + 1}</span>
                      <div className={Styles.actionQuetion}>
                        <div
                          className={Styles.trash}
                          onClick={() => {
                            const updateQuestions = thirdStep?.questions?.map(
                              (quest) => {
                                if (quest?.id === el?.id) {
                                  return {
                                    ...quest,
                                    action: "DELETE",
                                  };
                                } else {
                                  return quest;
                                }
                              }
                            );

                            setThirdStep((prev) => ({
                              ...prev,
                              questions: updateQuestions,
                            }));
                          }}
                        >
                          <Icon icon={"trash"} size={20} color={"#FF3E13"} />
                        </div>
                        <div className={Styles.line}></div>
                        <span className={Styles.requiredSpan}>Wajib diisi</span>
                        <ToggleButtonPIC
                          isPIC={el?.required}
                          handleIsPIC={() => {
                            const updateQuestions = thirdStep?.questions?.map(
                              (quest) => {
                                if (quest?.id === el?.id) {
                                  return {
                                    ...quest,
                                    required: true,
                                  };
                                } else {
                                  return quest;
                                }
                              }
                            );

                            setThirdStep((prev) => ({
                              ...prev,
                              questions: updateQuestions,
                            }));
                          }}
                          handleNotPIC={() => {
                            const updateQuestions = thirdStep?.questions?.map(
                              (quest) => {
                                if (quest?.id === el?.id) {
                                  return {
                                    ...quest,
                                    required: false,
                                  };
                                } else {
                                  return quest;
                                }
                              }
                            );

                            setThirdStep((prev) => ({
                              ...prev,
                              questions: updateQuestions,
                            }));
                          }}
                        />
                      </div>
                    </div>

                    <div className={Styles.contentQuestion}>
                      <div className={Styles.top}>
                        <InputField
                          isError={validate && !el?.question}
                          errorText="*Pertanyaan belum diisi"
                          value={el?.question}
                          placeholder="Tulis pertanyaan yang ingin Anda tanyakan"
                          onChange={(e) => {
                            const updateQuestions = thirdStep?.questions?.map(
                              (quest) => {
                                if (quest?.id === el?.id) {
                                  return {
                                    ...quest,
                                    question: e?.target.value,
                                  };
                                } else {
                                  return quest;
                                }
                              }
                            );

                            setThirdStep((prev) => ({
                              ...prev,
                              questions: updateQuestions,
                            }));
                          }}
                        />

                        <Dropdown
                          autoClose
                          value={el?.type}
                          setValue={(e) => {
                            const updateQuestions = thirdStep?.questions?.map(
                              (quest) => {
                                if (quest?.id === el?.id) {
                                  return {
                                    ...quest,
                                    type: e,
                                    answer:
                                      e === "Tanggal"
                                        ? {
                                            minDate: "",
                                            maxDate: "",
                                          }
                                        : "",
                                    optionAnswers:
                                      e === "Pilihan"
                                        ? [
                                            {
                                              id: 1,
                                              idUpdate: "",
                                              name: "",
                                              action: "CREATE",
                                            },
                                            {
                                              id: 2,
                                              idUpdate: "",
                                              name: "",
                                              action: "CREATE",
                                            },
                                          ]
                                        : [],
                                  };
                                } else {
                                  return quest;
                                }
                              }
                            );

                            setThirdStep((prev) => ({
                              ...prev,
                              questions: updateQuestions,
                            }));
                          }}
                          //   setValue={(e) => handleChange(e, "categoryPosition")}
                          isError={validate && !el?.type}
                          errorText="*Tipe pertanyaan belum dipilih"
                          placeholder={"Pilih kategori posisi"}
                          options={[
                            {
                              name: "Isian Singkat",
                            },
                            {
                              name: "Paragraf",
                            },
                            {
                              name: "Pilihan",
                            },
                            {
                              name: "Numerik",
                            },
                            {
                              name: "Tanggal",
                            },
                          ]}
                        />
                      </div>

                      <div className={Styles.bottom}>
                        {/* {el?.type === "Isian Singkat" && (
                          <InputField
                            isError={validate && !el?.answer}
                            errorText="*Jawaban belum diisi"
                            value={el?.answer}
                            placeholder="Jawaban yang diharapkan"
                            onChange={(e) => {
                              const updateQuestions = thirdStep?.questions?.map(
                                (quest) => {
                                  if (quest?.id === el?.id) {
                                    return {
                                      ...quest,
                                      answer: e?.target.value,
                                    };
                                  } else {
                                    return quest;
                                  }
                                }
                              );

                              setThirdStep((prev) => ({
                                ...prev,
                                questions: updateQuestions,
                              }));
                            }}
                          />
                        )} */}
                        {/* 
                        {el?.type === "Paragraf" && (
                          <InputField
                            isError={validate && !el?.answer}
                            errorText="*Jawaban belum diisi"
                            type={"desc"}
                            value={el?.answer}
                            placeholder="Jawaban yang diharapkan"
                            onChange={(e) => {
                              const updateQuestions = thirdStep?.questions?.map(
                                (quest) => {
                                  if (quest?.id === el?.id) {
                                    return {
                                      ...quest,
                                      answer: e?.target.value,
                                    };
                                  } else {
                                    return quest;
                                  }
                                }
                              );

                              setThirdStep((prev) => ({
                                ...prev,
                                questions: updateQuestions,
                              }));
                            }}
                          />
                        )} */}

                        {el?.type === "Numerik" && (
                          <InputField
                            isError={validate && !el?.answer}
                            errorText="*Jawaban belum diisi"
                            type={"number"}
                            value={el?.answer}
                            placeholder="Jawaban yang diharapkan"
                            onChange={(e) => {
                              const updateQuestions = thirdStep?.questions?.map(
                                (quest) => {
                                  if (quest?.id === el?.id) {
                                    return {
                                      ...quest,
                                      answer: e?.target.value,
                                    };
                                  } else {
                                    return quest;
                                  }
                                }
                              );

                              setThirdStep((prev) => ({
                                ...prev,
                                questions: updateQuestions,
                              }));
                            }}
                          />
                        )}

                        {el?.type === "Tanggal" && (
                          <div className={Styles.dateBox}>
                            <InputDateField
                              isError={validate && !el?.answer?.minDate}
                              errorText="*Jawaban belum diisi"
                              value={el?.answer?.minDate}
                              setValue={(newVal) => {
                                const updateQuestions =
                                  thirdStep?.questions?.map((quest) => {
                                    if (quest?.id === el?.id) {
                                      return {
                                        ...quest,
                                        answer: {
                                          minDate: newVal,
                                          maxDate: quest?.answer?.maxDate,
                                        },
                                      };
                                    } else {
                                      return quest;
                                    }
                                  });

                                setThirdStep((prev) => ({
                                  ...prev,
                                  questions: updateQuestions,
                                }));
                              }}
                              placeholder={"Rentang tanggal awal"}
                              type={"date"}
                            />

                            <div className={Styles.line}>
                              <div></div>
                            </div>
                            <InputDateField
                              isError={validate && !el?.answer?.maxDate}
                              errorText="*Jawaban belum diisi"
                              value={el?.answer?.maxDate}
                              setValue={(newVal) => {
                                const updateQuestions =
                                  thirdStep?.questions?.map((quest) => {
                                    if (quest?.id === el?.id) {
                                      return {
                                        ...quest,
                                        answer: {
                                          maxDate: newVal,
                                          minDate: quest?.answer?.minDate,
                                        },
                                      };
                                    } else {
                                      return quest;
                                    }
                                  });

                                setThirdStep((prev) => ({
                                  ...prev,
                                  questions: updateQuestions,
                                }));
                              }}
                              placeholder={"Rentang tanggal akhir"}
                              type={"date"}
                            />
                          </div>
                        )}

                        {el?.type === "Pilihan" &&
                          el?.optionAnswers?.filter(
                            (opA) => opA?.action !== "DELETE"
                          ).length > 0 &&
                          el?.optionAnswers
                            ?.filter((opA) => opA?.action !== "DELETE")
                            .map((option, opIdx) => {
                              return (
                                <div key={opIdx} className={Styles.options}>
                                  <Radio
                                    isError={validate && !el?.answer}
                                    isChecked={
                                      option?.name
                                        ? el?.answer === option?.name
                                        : false
                                    }
                                    setIsChecked={() => {
                                      if (option?.name) {
                                        const updateQuestions =
                                          thirdStep?.questions?.map((quest) => {
                                            if (quest?.id === el?.id) {
                                              return {
                                                ...quest,
                                                answer: option?.name,
                                              };
                                            } else {
                                              return quest;
                                            }
                                          });

                                        setThirdStep((prev) => ({
                                          ...prev,
                                          questions: updateQuestions,
                                        }));
                                      }
                                    }}
                                  />
                                  <InputField
                                    isError={validate && !option?.name}
                                    errorText=""
                                    value={option?.name}
                                    placeholder={`Opsi ${opIdx + 1}`}
                                    onChange={(e) => {
                                      const updateQuestions =
                                        thirdStep?.questions?.map((quest) => {
                                          if (quest?.id === el?.id) {
                                            return {
                                              ...quest,
                                              answer:
                                                quest?.answer === option?.name
                                                  ? ""
                                                  : quest?.answer,
                                              optionAnswers:
                                                quest?.optionAnswers?.map(
                                                  (op) => {
                                                    if (op?.id === option?.id) {
                                                      return {
                                                        ...op,
                                                        name: e.target.value,
                                                      };
                                                    } else {
                                                      return op;
                                                    }
                                                  }
                                                ),
                                            };
                                          } else {
                                            return quest;
                                          }
                                        });

                                      setThirdStep((prev) => ({
                                        ...prev,
                                        questions: updateQuestions,
                                      }));
                                    }}
                                  />

                                  <div
                                    className={Styles.iconDelete}
                                    onClick={() => {
                                      if (
                                        el?.optionAnswers?.filter(
                                          (opA) => opA?.action !== "DELETE"
                                        )?.length > 2
                                      ) {
                                        const updateQuestions =
                                          thirdStep?.questions?.map((quest) => {
                                            if (quest?.id === el?.id) {
                                              return {
                                                ...quest,
                                                optionAnswers:
                                                  quest?.optionAnswers?.map(
                                                    (op) => {
                                                      if (
                                                        op?.id === option?.id
                                                      ) {
                                                        return {
                                                          ...op,
                                                          action: "DELETE",
                                                        };
                                                      } else {
                                                        return op;
                                                      }
                                                    }
                                                  ),
                                              };
                                            } else {
                                              return quest;
                                            }
                                          });

                                        setThirdStep((prev) => ({
                                          ...prev,
                                          questions: updateQuestions,
                                        }));
                                      }
                                    }}
                                  >
                                    <Icon
                                      icon={"delete-outline"}
                                      size={24}
                                      color={
                                        el?.optionAnswers?.filter(
                                          (opA) => opA?.action !== "DELETE"
                                        )?.length === 2
                                          ? "#C2C2C2"
                                          : "#FF3E13"
                                      }
                                    />
                                  </div>
                                </div>
                              );
                            })}

                        {el?.type === "Pilihan" && (
                          <div className={Styles.addMoreOptions}>
                            <div className={Styles.dashed}></div>
                            <button
                              onClick={() => {
                                const updateQuestions =
                                  thirdStep?.questions?.map((quest) => {
                                    if (quest?.id === el?.id) {
                                      return {
                                        ...quest,
                                        optionAnswers: [
                                          ...quest?.optionAnswers,
                                          {
                                            id: Math.random(),
                                            idUpdate: "",
                                            name: "",
                                            action: "CREATE",
                                          },
                                        ],
                                      };
                                    } else {
                                      return quest;
                                    }
                                  });

                                setThirdStep((prev) => ({
                                  ...prev,
                                  questions: updateQuestions,
                                }));
                              }}
                            >
                              <Icon
                                icon={"add-circle"}
                                size={20}
                                color={"#1571DE"}
                              />
                              Tambah Opsi
                            </button>
                            <div className={Styles.dashed}></div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        )}

        <button
          onClick={() => {
            const newQuestiion = [
              ...thirdStep?.questions,
              {
                idUpdate: "",
                id: Math.random(),
                question: "",
                answer: "",
                type: "Isian Singkat",
                required: false,
                action: "CREATE",
                optionAnswers: [],
              },
            ];

            setThirdStep((prev) => ({
              ...prev,
              questions: newQuestiion,
            }));
          }}
          s
        >
          <Icon icon={"add-circle"} size={16} color={"#2E3192"} />
          Tambah pertanyaan
        </button>
      </div>
    </div>
  );
}
